import React from 'react'
import {useTranslation} from "react-i18next"
import cronstrue from 'cronstrue/i18n';

import {IonButtons, IonItem, IonLabel, IonNote, IonText} from "@ionic/react"

import {useDataSources as useItems}  from '../../../contexts/DataSourceContext'

import DataSource from "../../../types/DataSource"
import DataSourceSync      from "../../../types/DataSourceSync"
import IconDataSourceSync from "../../common/Icons/DataSourceSync";
import ListItemButtonIsEnabled from "../../common/Buttons/ListItemButtonIsEnabled";
import ListItemButtonSync from "./ButtonSync";

interface props {
    dataSource: DataSource;
    dataSourceSync: DataSourceSync;
    disabled: boolean;
}

const ListItem: React.FC<props> = ({ dataSource, dataSourceSync, disabled }: props) => {
    const { i18n, t } = useTranslation()
    const { runDataSourceSync, toggleDataSourceSyncIsEnabled } = useItems()

    return (
        <IonItem
            disabled={disabled}
            lines="inset"
            key={"dataSource-" + dataSource.id + '-dataSourceSync-' + dataSourceSync.id}
        >
            <IconDataSourceSync slot="start" />
            <IonLabel>
                {t('data-source-syncs.names.' + dataSourceSync.dataSourceSyncType.name + '.name')}
                <p>
                    {t('data-source-syncs.names.' + dataSourceSync.dataSourceSyncType.name + '.description')}
                </p>
                <IonText className="ion-hide-sm-up" color="secondary">
                    {cronstrue.toString(dataSourceSync.cronSchedule, {
                        "locale":  i18n.language,
                        "verbose": true
                    })}
                </IonText>
            </IonLabel>
            <IonNote className="ion-padding-end ion-hide-sm-down" slot="end">
                {cronstrue.toString(dataSourceSync.cronSchedule, {
                    "locale":  i18n.language,
                    "verbose": true
                })}
            </IonNote>
            <IonButtons slot="end">
                <ListItemButtonIsEnabled
                    disabled={! dataSource.isEnabled}
                    item={dataSourceSync}
                    toggle={toggleDataSourceSyncIsEnabled}
                />
                <ListItemButtonSync
                    disabled={! Boolean(dataSourceSync.manualSync) || dataSourceSync.hasLock}
                    item={dataSourceSync}
                    sync={runDataSourceSync}
                />
            </IonButtons>
        </IonItem>
    )
}

export default ListItem